import { useQuery } from 'react-query';
import { useServices } from '../../../services/useServices';
import { IBookstatProcessingStatusResponse } from '../book.dto';

const useBookstatProcessingStatus = (format = 'ebook') => {
  const {
    book: { getBookstatProcessingStatus }
  } = useServices();

  const res = useQuery<IBookstatProcessingStatusResponse, Error>(
    ['bookstat-processing-status', format],
    () => getBookstatProcessingStatus(format),
    {
      refetchInterval: false,
      cacheTime: 0,
      retry: false
    }
  );

  return {
    data: res.data,
    isLoading: res.isLoading,
    isError: res.isError,
    error: res.error
  };
};

export default useBookstatProcessingStatus;